import React, {useEffect} from 'react';
import axios from 'axios';
import {Col, Container, Row} from 'reactstrap';
import classNames from 'classnames';
import {DateTime} from 'luxon';
import PageMeta from 'components/PageMeta';
import ABTest, {DebugMenu} from 'react-controlled-ab';
import {subscribeToCampaign} from 'react-controlled-ab/datalayers/vwo';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faLock} from '@fortawesome/pro-light-svg-icons';

import {usePhaseState, usePhaseDispatch} from 'funnel-schedule/phase-context';
import {useUserState, useUserDispatch} from 'contexts/user';
import track from 'utils/track';

import Divider from 'components/Divider';
import SalesCopy from 'components/SalesCopy';
import {SalesCtaScreeningFull} from 'components/SalesCta';
import CheckoutButton from 'components/CheckoutButton';
import ModalExitScreening from 'components/ModalExitScreening';
import RegistrationModal from 'components/RegistrationModal';
import ShareButtons from 'components/ShareButtons';
import Footer from 'components/Footer';
import WebinarVideo from 'components/WebinarVideo';

//Due to a limitation of dotenv we must use three seperate statements
const {SF_API_URL} = process.env;
const {SITE_ID} = process.env;

export default function Screening({screeningFull = false, ...props}) {
  const phaseDispatch = usePhaseDispatch();
  const userDispatch = useUserDispatch();
  const {phases = {}} = usePhaseState();
  const {default: context = {}} = phases;
  const {phase} = context;
  const {events = [], registrationId} = useUserState();
  const videoWatched = events.includes('Watched TNTG Screening');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    registrationId &&
      axios
        .get(`${SF_API_URL}/site/${SITE_ID}/state/`, {
          params: {
            registrationId
          }
        })
        .then(({data}) => {
          if (!data.webinar) {
            data.webinar = {
              phase: 'after',
              time: Math.floor(DateTime.utc().minus({days: 5}).toSeconds())
            };
          }
          const {firedEvents = []} = data.webinar;

          phaseDispatch({
            type: 'SET_PHASE',
            payload: data
          });
          firedEvents.map((e) => userDispatch({type: 'ADD_EVENT', payload: e}));
        });
  }, []);

  useEffect(
    () =>
      track('Product Viewed', {
        product_id: 'tntg',
        sku: 'tntg',
        name: 'TNTG Impact Kit',
        variant: 'tntg-impactkit-special-wlc-30daytrial-st',
        value: 67,
        currency: 'usd'
      }),
    []
  );
  useEffect(
    () =>
      track('Product Viewed', {
        product_id: 'tntg',
        sku: 'tntg',
        name: 'TNTG Film',
        variant: 'tntg-special',
        value: 7,
        currency: 'usd'
      }),
    []
  );

  return (
    <div className="screening-page page d-flex flex-column">
      <PageMeta />

      <div className="page-content">
        <div className="background-gradient-yellow-white">
          <div className="background-black triangle-bottom triangle-bottom-black wrapper">
            <div className="offset-header-during">
              <Container>
                <Row>
                  <Col>
                    <h3 className="text-center text-800 text-white mb-2">
                      Welcome to the exclusive online <br className="d-none d-lg-block" />
                      screening of <em>The Need To GROW.</em>
                    </h3>
                    <h5 className="text-center text-800 text-white mb-0">
                      An environmental film to <br className="d-none d-sm-block d-md-none" />
                      give the world hope.
                    </h5>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
          <div className="video-box offset-video-box-during pb-5">
            <Container>
              <Row>
                <Col className="px-0 px-sm-3">
                  <WebinarVideo
                    noun="Your Free Screening"
                    events={events}
                    url="https://customer-ros8xhsmbkksflna.cloudflarestream.com/8edd0080b50841209215b9d9ea46827e/manifest/video.m3u8"
                    label="TNTG - Film"
                  />
                </Col>
              </Row>
            </Container>
          </div>
        </div>

        <Divider />

        <div className="takehome triangle-angles-offset-bottom wrapper">
          <Container>
            <Row className="d-flex align-items-center justify-content-center">
              <Col xs="8" sm="6" lg="4" className="text-center mb-4 mb-lg-0">
                <img src="https://cdn.foodrevolution.org/tntg/social/tntg-iv-square.jpg" />
              </Col>
              <Col xs="12" md="10" lg="8" xl="7" className="text-center text-lg-left">
                <h4 className="text-condensed text-800 mb-3">
                  Feeling inspired and want <br className="d-none d-md-block d-xl-none" />
                  to <em>stay</em> that way?
                </h4>
                <h4 className="text-condensed text-800">
                  Own the movie for life and help spread <br className="d-none d-sm-block d-md-none" />
                  this urgent mission now.
                </h4>
                <h5 className="mb-2">
                  <strong>Right now just $7!</strong>
                </h5>
                <p className="mb-4">(Less than the cost of a movie ticket!)</p>
                <CheckoutButton className="btn-size-350" sku="tntg" price="7" slug="tntg-special" />
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="offer-box-details text-center mt-4">
                  <div className="offer-box-cards">
                    <img
                      className="img-fluid img-cc"
                      src="https://cdn.foodrevolution.org/global/images/payments-accepted-20240424.svg"
                      width={1800}
                      height={175}
                    />
                  </div>
                  <div className="offer-box-security">
                    <FontAwesomeIcon className="offer-box-security-icon mr-2" icon={faLock} />
                    For your security, all orders are processed on a secured server.
                  </div>
                  <div className="offer-box-protected d-flex justify-content-center">
                    Your purchase is protected by our 60-day money back guarantee.
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <SalesCopy
          salesCta={
            <>
              <SalesCtaScreeningFull trees />
            </>
          }
        />
      </div>
      <div className="mt-auto">
        <Footer />
        <ShareButtons floating />
      </div>
      <ModalExitScreening />
    </div>
  );
}
